/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs */

const en_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize Phrases`)
};

const ar_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخصيص العبارات`)
};

const de_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phrasen anpassen`)
};

const es_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personaliza tus frases`)
};

const fr_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisez vos phrases`)
};

const it_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizza frasi`)
};

const ja_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーズのカスタマイズ`)
};

const ko_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나만의 문구 만들기`)
};

const pt_br_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frases personalizadas`)
};

const ru_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка фраз`)
};

const th_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปรับแต่งคำพูด`)
};

const tr_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İfadeleri Özelleştir`)
};

const zh_cn_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自订鼓励语句`)
};

const zh_tw_subscription_exclusive_feature_encourage_phrase_title = /** @type {(inputs: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自訂鼓勵語句`)
};

/**
* | output |
* | --- |
* | "Customize Phrases" |
*
* @param {Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_encourage_phrase_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Encourage_Phrase_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_encourage_phrase_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_encourage_phrase_title(inputs)
	return zh_tw_subscription_exclusive_feature_encourage_phrase_title(inputs)
});